import {useMatches} from "react-router";
import {MatchedRoutes} from "@Routing/types/MatchedRoutes.type";

export default function useRouteMatch(match: MatchedRoutes) {
    const matches = useMatches();
    return matches.find(({id}) => id === match)
}